(function () {
  // Collection sort dropdown: reload with the chosen sort order.
  document.addEventListener('change', function (e) {
    var el = e.target;
    if (el && el.matches && el.matches('[data-sort-select]')) {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', el.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    }
  });

  // Product page: update price and gallery-independent variant id when the selector changes.
  document.addEventListener('change', function (e) {
    var el = e.target;
    if (el && el.matches && el.matches('[data-variant-select]')) {
      var opt = el.options[el.selectedIndex];
      var priceEl = document.querySelector('[data-product-price]');
      var compareEl = document.querySelector('[data-product-compare]');
      var btn = document.querySelector('[data-add-button]');
      if (priceEl && opt.dataset.price) priceEl.textContent = opt.dataset.price;
      if (compareEl) {
        compareEl.textContent = opt.dataset.compare || '';
        compareEl.hidden = !opt.dataset.compare;
      }
      if (btn) {
        var soldOut = opt.dataset.available === 'false';
        btn.disabled = soldOut;
        btn.textContent = soldOut ? 'Sold out' : btn.getAttribute('data-label');
      }
    }
  });
})();
